import {
  ItineraryItemSchema,
  TripItemSchema,
  TripType,
} from "src/utils/ApiSchema";

export const backgroundVideoUrl =
  "https://res.cloudinary.com/stt-mvp/video/upload/v1700694541/vid_dgzikf.mp4";

export const trips: TripItemSchema[] = [
  {
    id: "1",
    createdId: "1",
    name: "Trip name",
    type: TripType.Accommodation,
    start: {
      location: "Surat",
      time: "Sun Mar 02 2025 14:41:57 GMT+0530",
    },
    end: {
      location: "Los Angeles",
      time: "Mon Mar 03 2025 16:41:57 GMT+0530",
    },
    cost: {
      totalValue: 267,
      currency: "$",
      userValue: 267,
      userCurrency: "USD",
    },
    booking: null,
    completed: true,
  },
  {
    id: "2",
    createdId: "2",
    name: "Trip name 2",
    type: TripType.Transport,
    start: {
      location: "Surat",
      time: "Sun Mar 02 2025 14:41:57 GMT+0530",
    },
    end: {
      location: "New York",
      time: "Mon Mar 03 2025 16:41:57 GMT+0530",
    },
    cost: {
      totalValue: 300,
      currency: "$",
      userValue: 300,
      userCurrency: "USD",
    },
    booking: null,
    completed: false,
  },
  {
    id: "3",
    createdId: "3",
    name: "Trip name 3",
    type: TripType.Activities,
    start: {
      location: "Surat",
      time: "Sun Mar 02 2025 14:41:57 GMT+0530",
    },
    end: {
      location: "Dallas",
      time: "Mon Mar 03 2025 16:41:57 GMT+0530",
    },
    cost: {
      totalValue: 800,
      currency: "$",
      userValue: 800,
      userCurrency: "USD",
    },
    booking: null,
    completed: true,
  },
];

export const itineraries: ItineraryItemSchema[] = [
  {
    id: "1",
    createdId: "1",
    name: "Dubai Tour",
    completed: false,
    location: "Dubai",
    time: new Date().toString(),
    cost: {
      totalValue: 1000,
      currency: "$",
      userValue: 1000,
      userCurrency: "USD",
    },
    trips: trips,
  },
];
